import script from "./WhatsAppThreadCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsAppThreadCard.vue?vue&type=script&setup=true&lang=ts"

import "./WhatsAppThreadCard.vue?vue&type=style&index=0&id=31039a1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31039a1a"]])

export default __exports__